import { Component, Input } from '@angular/core';
import { AdditionalCoverageBoxForEnumComponent } from '@shared/components/additional-coverage-for-enum/additional-coverage-box-for-enum.component';
import { SkipperFormModel } from '@shared/models/forms/skipper-form.model';
import { FormGroup } from '@angular/forms';
import { AdditionalCoverageBoxComponent } from '@shared/components/additional-coverage-box/additional-coverage-box.component';
import { CallidusSkipperVersicherungssummeKunde } from '@backend/models';

@Component({
  selector: 'app-skipper-haftpflicht',
  templateUrl: './skipper-haftpflicht.component.html',
  imports: [
    AdditionalCoverageBoxForEnumComponent,
    AdditionalCoverageBoxComponent
  ],
  styleUrl: './skipper-haftpflicht.component.scss'
})
export class SkipperHaftpflichtComponent {
  @Input() form!: FormGroup<SkipperFormModel>;
  
  protected readonly CallidusSkipperVersicherungssummeKunde = CallidusSkipperVersicherungssummeKunde;
}
